import React from 'react';
import { connect } from 'react-redux';
// AssetsRowPicker imports
import { prevScroll, nextScroll } from '../../actions/assetRowPickerActions';
import PrefabItem from './prefabItem';
// Shared imports
import settings from '../../../settings';

const longPressTime = 500;
const longPressDelay = 50;

class AssetRowPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nextDown: false,
            nextLongPress: false,
            prevDown: false,
            prevLongPress: false
        };
    }

    getScrollIndex = category => {
        const { assetRowPicker } = this.props;
        const indices = assetRowPicker.scrollIndex;
        if (!hasOwnProperty.call(indices, category)) {
            return 0;
        }

        return indices[category];
    };

    handleNextPress = () => {
        this.setState({ nextDown: true });
        this.nextPressTimer = setTimeout(() => {
            this.setState({ nextLongPress: true });
            this.handleNextLongPress();
        }, longPressTime);
    };

    handleNextRelease = () => {
        const { nextLongPress, nextDown } = this.state;

        clearTimeout(this.nextPressTimer);
        clearTimeout(this.handleNextLongPressTimer);

        if (!nextLongPress && nextDown) {
            this.doNextScroll();
            this.setState({ nextDown: false });
        } else {
            this.setState({ nextLongPress: false });
        }
    };

    handleNextLongPress = () => {
        this.doNextScroll();
        this.handleNextLongPressTimer = setTimeout(this.handleNextLongPress, longPressDelay);
    };

    doNextScroll = () => {
        const { dispatch, currentCategory, items, maxItemsInRow } = this.props;
        if (items.length <= maxItemsInRow + this.getScrollIndex(currentCategory)) return;
        dispatch(nextScroll(currentCategory));
    };

    handlePrevPress = () => {
        this.setState({ prevDown: true });
        this.prevPressTimer = setTimeout(() => {
            this.setState({ prevLongPress: true });
            this.handlePrevLongPress();
        }, longPressTime);
    };

    handlePrevRelease = () => {
        const { prevLongPress, prevDown } = this.state;

        clearTimeout(this.prevPressTimer);
        clearTimeout(this.handlePrevLongPressTimer);

        if (!prevLongPress && prevDown) {
            this.doPrevScroll();
            this.setState({ prevDown: false });
        } else {
            this.setState({ prevLongPress: false });
        }
    };

    handlePrevLongPress = () => {
        this.doPrevScroll();
        this.handlePrevLongPressTimer = setTimeout(this.handlePrevLongPress, longPressDelay);
    };

    doPrevScroll = () => {
        const { dispatch, currentCategory } = this.props;
        if (this.getScrollIndex(currentCategory) <= 0) return;
        dispatch(prevScroll(currentCategory));
    };

    setHoveredPrefabName = name => {
        const { setHoveredPrefabName } = this.props;

        if (setHoveredPrefabName) {
            setHoveredPrefabName(name);
        }
    };

    getItems = () => {
        const { handleItemClick, draggable, items, maxItemsInRow, activeItem, currentCategory } = this.props;

        const jsxItems = [];
        for (let i = 0; i < maxItemsInRow && i < items.length; i += 1) {
            const item = items[i + this.getScrollIndex(currentCategory)];
            if (item) {
                jsxItems.push(
                    <PrefabItem
                        key={item.id}
                        active={activeItem === item.id}
                        item={items[i + this.getScrollIndex(currentCategory)]}
                        setHoveredPrefabName={this.setHoveredPrefabName}
                        handleItemClick={handleItemClick}
                        draggable={draggable}
                    />
                );
            }
        }

        if (items.length < maxItemsInRow) {
            for (let i = 0; i < maxItemsInRow - items.length; i += 1) {
                jsxItems.push(<div key={i} className="category-prefab-item category-prefab-item-placeholder"><div className="placeholder" /></div>);
            }
        }

        return jsxItems;
    };

    render = () => {
        const { active, items, maxItemsInRow, currentCategory } = this.props;

        if (!active) return null;

        const scrollIndex = this.getScrollIndex(currentCategory);

        return (
            <div ref={this.assetRowPickerContainer}>
                <div className="item-selector-category-display" id="item-selector-items-display">
                    <div
                        className={`btn-category-scroll category-scroll-left direction-left${scrollIndex <= 0 ? ' btn-category-scroll-disabled' : ''}`}
                        onMouseDown={this.handlePrevPress}
                        onMouseUp={this.handlePrevRelease}
                        onMouseLeave={this.handlePrevRelease}
                        onTouchStart={this.handlePrevPress}
                        onTouchEnd={this.handlePrevRelease}
                        onTouchCancel={this.handlePrevRelease}
                        role="button"
                        tabIndex={0}
                    >
                        <img src={`${settings.assetsPath}img/icons/pijl.png`} alt="scroll left" title="scroll left" />
                    </div>
                    <div className="items-container-wrapper">
                        <div className="items-container no-scroll-bar">{this.getItems()}</div>
                    </div>
                    <div
                        className={`btn-category-scroll category-scroll-right direction-right ${items.length <= maxItemsInRow + scrollIndex ? ' btn-category-scroll-disabled' : ''}`}
                        onMouseDown={this.handleNextPress}
                        onMouseUp={this.handleNextRelease}
                        onMouseLeave={this.handleNextRelease}
                        onTouchStart={this.handleNextPress}
                        onTouchEnd={this.handleNextRelease}
                        onTouchCancel={this.handleNextRelease}
                        role="button"
                        tabIndex={0}
                    >
                        <img src={`${settings.assetsPath}img/icons/pijl.png`} alt="scroll right" title="scroll right" />
                    </div>
                </div>
            </div>
        );
    };
}

AssetRowPicker.defaultProps = {
    active: true,
    currentCategory: '',
    maxItemsInRow: 5
};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    assetRowPicker: state.assetRowPicker
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssetRowPicker);
